import React from 'react';
import { VisibilityOutlined } from '@mui/icons-material';
import { IAMCRequest } from '../../../utils/entities/interface';
import { capitalizeWords } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { ListTable } from '../../molecules/ListTable';

export const AmcRequests = ({
  requests,
  isLoading,
  onUpdate,
  tableCell = [],
}: {
  requests: IAMCRequest[];
  isLoading: boolean;
  onUpdate: () => void;
  tableCell?: any[];
}) => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: <VisibilityOutlined fontSize="small" />,
      onClick: (row: any) => navigate(`/amc/request-details/${row._id}`),
    },
  ];

  return (
    <ListTable
      headerCells={tableCell}
      rows={requests}
      isLoading={isLoading}
      actions={actions}
      renderCell={(request: any, colIndex: number) => {
        switch (colIndex) {
          case 0: // Booking ID
            // `enquiryId` (e.g. "NVKEQ0812-5") is the human-readable
            // reference. `bookingId` on an enquiry record is a raw Mongo
            // ObjectId pointing at the linked Booking document, not a
            // display-friendly string — showing it directly is what made
            // this column look "incorrect", so it's only a last resort.
            return request.enquiryId || request.bookingId || '-';
          case 1: // User Name
            return capitalizeWords(request?.user?.name) || 'N/A';
          case 2: // Request Type
            return request?.subType || 'AMC';
          case 3: // Inspector Name
            return request?.technicianName
              ? capitalizeWords(request.technicianName)
              : 'Unassigned';
          case 4: // User Contact
            return request?.user?.phoneNumber
              ? `+91 - ${request.user.phoneNumber}`
              : 'N/A';
          case 5: // Booking Slot
            return request?.schedule?.slot || request?.slot || 'N/A';
          case 6: // Status
            return request?.status || 'N/A';
          default:
            return null;
        }
      }}
    />
  );
};
